import type React from "react"
import { Box, Typography, Avatar } from "@mui/material"
import { formatDistanceToNow } from "date-fns"
import { es } from "date-fns/locale"
import type { MessageDto } from "../../types/message"
//import type { NormalizedMessage } from "../../types/normalizedMessage"

interface ChatMessageProps {
  message: MessageDto
  isCurrentUser: boolean
  showAvatar: boolean
  userProfileId: number | undefined
}

const ChatMessage: React.FC<ChatMessageProps> = ({ message, isCurrentUser, showAvatar, userProfileId }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: isCurrentUser ? "flex-end" : "flex-start",
        mb: 1.5,
      }}
    >
      {!isCurrentUser && showAvatar && (
        <Avatar
          src={message.senderProfile?.avatarUrl || "/assets/images/profilePicture.png"}
          alt={message.senderProfile?.username || "Usuario"}
          sx={{ width: 36, height: 36, mr: 1, mt: 0.5 }}
        // src={message.senderProfilePicture || "/assets/images/profilePicture.png"}
        // alt={message.senderName}
        // sx={{ width: 36, height: 36, mr: 1, mt: 0.5 }}
        />
      )}
      {!isCurrentUser && !showAvatar && <Box sx={{ width: 36, mr: 1 }} />}

      <Box
        sx={{
          maxWidth: "70%",
          p: 2,
          borderRadius: "16px",
          bgcolor: isCurrentUser ? "success.light" : "grey.100",
          color: isCurrentUser ? "white" : "text.primary",
          position: "relative",
        }}
      >
        {!isCurrentUser && showAvatar && (
          <Typography variant="caption" sx={{ display: "block", mb: 0.5, fontWeight: "medium" }}>
            {message.senderProfile?.username || "Usuario"}
          </Typography>
        )}
        <Typography variant="body1">{message.content}</Typography>
        <Typography
          variant="caption"
          sx={{
            display: "block",
            textAlign: "right",
            mt: 0.5,
            color: isCurrentUser ? "rgba(255,255,255,0.7)" : "text.secondary",
          }}
        >
          {formatDistanceToNow(new Date(message.sentAt), {
            addSuffix: true,
            locale: es,
          })}
        </Typography>
      </Box>
    </Box>
  )
}

export default ChatMessage
